import { hydra } from '@/lib/services/Hydra'
import { logError } from '@/lib/utils/shared/log'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'

export const useDoesUserHaveActiveSubscription = () => {
  const {
    user: { token },
    setAppAddProductToSubscription,
  } = useGlobalStore()

  const [isLoadingHasActiveSubscription, setIsLoadingHasActiveSubscription] =
    useState(true)

  useEffect(() => {
    if (token === null) return
    ;(async () => {
      setIsLoadingHasActiveSubscription(true)
      const me = await hydra.getMe({ hydraToken: token })

      if (me?.subscriptionRenewalDate) {
        setAppAddProductToSubscription({
          userHasActiveSubscription: true,
        })

        return
      }

      setAppAddProductToSubscription({
        userHasActiveSubscription: false,
      })
    })()
      .catch((error) => {
        logError(error)
      })
      .finally(() => {
        setIsLoadingHasActiveSubscription(false)
      })
  }, [token])

  return { isLoadingHasActiveSubscription }
}
